module.exports = __webpack_public_path__ + "static/media/Trophy 2.c95395ad.png";